import {html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {classMap} from 'lit/directives/class-map.js';
import {ListSelect} from '../../../components/widgets/listSelect';
import store from '../../../store';
import {selectSolarHeight} from '../../solarSelectors';

@customElement('height-select')
export class HeightSelect extends ListSelect {


	render() {
		const titleAddon1 = {
			en: '(above base mast)',
			fr: '(au dessus du mât de base)',
			de: '(über Basismast)',
		};
		const titleAddon2 = {
			en: '',
			fr: '',
			de: '',
		};

		const s = store.getState();
		if (!this.isVisible(s)) return null;

		const baseHeightValue = selectSolarHeight(s);
		const baseHeight = baseHeightValue ? parseInt(baseHeightValue, 10) / 10 : 0;
		let title = this.title[this.lang] + ' ' + titleAddon1[this.lang];
		if (baseHeight > 0) {
			title = this.title[this.lang] + ' ' + titleAddon2[this.lang];
		}

		return html`
			<div>
				<div class="title">
					${title}
				</div>
				<div class="values ${classMap({notSatisfied: !this.isSatisfied(s)})}">
					${repeat([...this.options],
							(option) => option.id,
							(option) => html`
								<height-select-item .option=${option}
												  .canBeSelected=${this.canBeSelected(s, option.id)}
												  selected=${this.selected(s)}
												  .hideDisabled=${this.hideDisabled}
												  action="${this.action}"></height-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
